import {
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { masks } from '../../shared/constants/masks';
import { FormControlService } from 'src/app/services/form-control.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';

import { DtmService } from 'src/app/services/dtm.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DisconnectdSaleService } from 'src/app/shared/services/disconnectd-sale.service';
import { Register } from 'src/app/shared/model/register';
import { CatalogService } from 'src/app/shared/services/catalog.service';
import { CartService } from 'src/app/shared/services/cart.service';
import { Cart } from 'src/app/shared/model/cart';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { Customer } from 'src/app/shared/model/customer';
import { Dtm, getDtm } from 'src/app/shared/enum/dtm';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'pme-identification',
    templateUrl: './identification.component.html',
    styleUrls: ['./identification.component.scss'],
    standalone: false
})
export class IdentificationComponent implements OnInit, OnChanges {

  // Buttons and Bottom Sheet Cart Component Variables

  onSubmitIdentificationErrors: Array<string> = [];
  identificationForm: UntypedFormGroup;
  masks = masks;

  carts: Array<Cart>;
  cart: Cart;

  productId: string;
  productIdentifier: string;
  productFamily: string;
  productClassId: string;
  productFamilyIdentifier: string;
  productName: string;
  valuePerMonth: string;
  productType: string;
  totalValue: string;
  productImg: string;
  successIdentificationMessage: string | null = null;
  installments: number;
  productValue: string;
  discountedValue: string;
  hideFields: any = {};
  checkoutDeslogadoTag: string;
  spinnerDialogRef: MatDialogRef<LoadingComponent>;
  lastFieldValues: { [key: string]: any } = {};
  hideIdentification: boolean = true;
  emailsMatch: boolean = false;
  firstSubmit = true;
  submitting: boolean = false;
  show: boolean = false;
  lastFocusedField: string | null = null;
  lastFieldValue: any = null;
  //hasUserAndBusinessData: boolean = false;
  accountExists: boolean = false;
  private PLAN_CLASS_ID = "5cb5bd2a21dc1273415874b1";
  private UNIT_PRODUCT_CLASS_ID = "5cb5bddf21dc12734158758a";
  constructor(
    private catalogService: CatalogService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public formControlService: FormControlService,
    private customerService: CustomerService,
    public dtmService: DtmService,
    public dialog: MatDialog,
    public cartService: CartService,
    private disconnectedSaleService: DisconnectdSaleService,
    private formBuider: UntypedFormBuilder
  ) {
    this.sessionStorageService.setCustomData('disconnectedSaleStep', 'identification');
    this.productIdentifier = this.route.snapshot.queryParams['productIdentifier'] || this.navigateToNotFound();
    this.sessionStorageService.setCustomData('productIdentifier', this.productIdentifier);
    this.getProductData();
  }

  ngOnInit() {
    this.checkoutDeslogadoTag = "CheckoutCompraDeslogada:CadastroDeslogado";
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngAfterViewInit(): void {
  }

  ngDoCheck(): void {
  }

  onLinkClick() {
    this.dtmService.productsLoaded([{
      identifier: this.productIdentifier,
      classificationName: this.productName,
      quantity: 1,
      totalValue: this.totalValue.replace(',','.'),
    },]);

    this.dtmService.pageLoaded(Dtm.CadastroDeslogado, true, getDtm(Dtm.CadastroDeslogado, this.productFamilyIdentifier));
    this.dtmService.customClickEvent(this.checkoutDeslogadoTag + "JaPossuoCadastro")

    window.location.href = environment.redirect_disconnect_sale + 'login';
  }
  onBlurField(campo: string): void {
    const control = this.formControlService.identificationDisconnectedSaleForm.get(campo);
    if (!control) return;

    const currentValue = control.value;
    const lastValue = this.lastFieldValues[campo];

    if (currentValue !== lastValue) {
      this.handleFieldValueChange(campo);
      this.lastFieldValues[campo] = currentValue;
    }
  }
  checkEmailsMatch(): void {
    const email = this.formControlService.identificationDisconnectedSaleForm.get('email')?.value;
    const emailConfirm = this.formControlService.identificationDisconnectedSaleForm.get('emailConfirm')?.value;

    this.emailsMatch = email && emailConfirm && email === emailConfirm;

    if (this.emailsMatch) {
      this.verifyEmail(email);
    }
  }
  handleFieldValueChange(campo: string): void {
    const control = this.formControlService.identificationDisconnectedSaleForm.get(campo);
    if (!control) return;

    this.dtmService.productsLoaded([{
      identifier: this.productIdentifier,
      classificationName: this.productName,
      quantity: 1,
      totalValue: this.totalValue.replace(',','.'),
    }]);

    this.dtmService.pageLoaded(
      Dtm.CadastroDeslogado,
      true,
      getDtm(Dtm.CadastroDeslogado, this.productFamilyIdentifier)
    );

    this.dtmService.customClickEvent(this.checkoutDeslogadoTag, campo);
  }
  closeDialogSpinner(): void {
    this.hideValidFields();

    if (this.spinnerDialogRef) {
      this.spinnerDialogRef.close();
    }
    this.hideIdentification = false;
  }

  private resetPersonalDataFields(userData?: any, businessData?: any): void {
    const form = this.formControlService.identificationDisconnectedSaleForm;
  
    if(!userData && !businessData) {
      const fieldsToReset = ['name', 'cpf', 'cnpj', 'birthDate', 'phone'];
      fieldsToReset.forEach(fieldName => {
        const control = form.get(fieldName);
        if (control) {
          control.reset('');
          control.enable();
        }
      });
    }else {
      this.formControlService.identificationDisconnectedSaleForm.patchValue({
        name: userData.fullName || '',
        cnpj: businessData?.companyDocument?.nationalRegistrationId || '',
        cpf: userData.document?.documentId || '',
        birthDate: userData.birthDate? this.formatToBrDate(userData.birthDate) : '',
        phone: userData.mobile? this.getMobilePhoneNumberOfPersonaldata(userData.mobile) : ''
      });
    }
    
  }

  private getMobilePhoneNumberOfPersonaldata(mobile: any){
    return String(mobile?.regionCode || '') + String(mobile?.areaCode || '') + String(mobile?.phoneNumber || '');
  }

  private formatToBrDate(date: string) {
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  }

  hideValidFields() {
    if (this.formControlService.identificationForm.valid === false) {
      this.hideFields.legalName = this.formControlService.identificationForm.controls.legalName.disabled;
      this.hideFields.cpf = this.formControlService.identificationForm.controls.cpf.disabled;
      this.hideFields.cnpj = this.formControlService.identificationForm.controls.cnpj.disabled;
      this.hideFields.name = this.formControlService.identificationForm.controls.name.disabled;
      this.hideFields.birthDate = this.formControlService.identificationForm.controls.birthDate.disabled;
      this.hideFields.email = this.formControlService.identificationForm.controls.email.disabled;
      this.hideFields.cellphone = this.formControlService.identificationForm.controls.cellphone.disabled;
    }
  }

  verifyEmail(email: string): void {
    this.openDialogSpinner();

    this.disconnectedSaleService.getFullUserData(email).subscribe({
      next: (res) => {
        this.accountExists = res.accountExists;
        this.closeDialogSpinner();

        if (this.accountExists) {
          this.hideIdentification = true;
          this.successIdentificationMessage = 'Tudo pronto para seguir com a contratação.';
        } else {
          this.resetPersonalDataFields(res.userData,res.businessData);
          this.successIdentificationMessage = null;
          this.hideIdentification = false;
        }

      },
      error: () => {
        this.closeDialogSpinner();
        this.hideIdentification = false;
        this.resetPersonalDataFields();
        this.successIdentificationMessage = null;
      }
    });
  }
  register() {
    this.dtmService.productsLoaded([{
      identifier: this.productIdentifier,
      classificationName: this.productName,
      quantity: 1,
      totalValue: this.totalValue.replace(',','.'),
    },]);

    this.dtmService.pageLoaded(Dtm.CadastroDeslogado, true, getDtm(Dtm.CadastroDeslogado, this.productFamilyIdentifier));
    this.dtmService.customClickEvent(this.checkoutDeslogadoTag + "CadastreSeAgora")
    this.submitting = true;
    this.disconnectedSaleService.registerUser(new Register(this.formControlService.identificationDisconnectedSaleForm.getRawValue())).subscribe({
      next: (res) => {
        let customer = new Customer(res);
        if (customer.provisioningParameter.accountExists === true) {
          this.productType = this.productClassId === this.PLAN_CLASS_ID
            ? "plan"
            : "package";
          let queryParams: any = {
            "businessId": customer.provisioningParameter.businessId,
            "userId": customer.provisioningParameter.userId
          };
          if (this.productType === "plan") {
            queryParams.plan = this.productIdentifier
          } else {
            queryParams.package = this.productIdentifier
          }
          this.router.navigate(
            ["/" + this.productFamilyIdentifier + "/checkout/identificacao"],
            {
              queryParams: queryParams
            }
          );
          return;
        }
        const { zipCode, city, street, district, state } = res.address;
        customer.zipcode = zipCode;
        customer.city = city;
        customer.street = street;
        customer.quarter = district;
        customer.state = state;
        let streetSplit = street.split(' ');
        customer.number = streetSplit[streetSplit.length - 1];
        this.customerService.setCurrentCustomer(customer);
        this.sessionStorageService.setValidationDataFromCustomer(customer);
        this.navigateToNextStep();

      },
      error: (res) => {
        const error_JSON = JSON.parse(res.error.generalMessages[0].text);
        this.onSubmitIdentificationErrors = [error_JSON.messageFront];
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: "HTTTP:" + res.status + "POST:" + res.url + ":" + "[" + error_JSON.errorContent + "]" + "[]",
          errorMessage: error_JSON.errorTitle,
          customLink: "customError"
        });
        this.submitting = false;
      }
    });
  }
  canSubmit(): boolean {
    const form = this.formControlService.identificationDisconnectedSaleForm;
    if (this.submitting) {
      return false;
    }
    if (!this.accountExists) {
      return form.valid;
    }
    return true;
  }
  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.hideIdentification = this.firstSubmit;
    this.spinnerDialogRef = this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: '400px',
      panelClass: 'pme-dialog-loading-panel',
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }
  navigateToNextStep() {
    this.router.navigate(['../pagamento'], { relativeTo: this.route });
  }

  navigateToNotFound() {
    this.router.navigate(['']);
  }

  formatParameterForField(value, type): string {
    let formatted = '';
    let regex: RegExp;
    let format: string;

    if (!value) {
      return;
    }

    if (type === 'cpf') {
      regex = new RegExp(/^(\d{3})(\d{3})(\d{3})(\d{2})/g);
      format = '$1.$2.$3-$4'; // 123.456.789-01
    } else if (type === 'cnpj') {
      regex = new RegExp(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g);
      format = '$1.$2.$3/$4-$5'; // 83.594.046/0001-03
    } else if (type === 'birthDate') {
      regex = new RegExp(/^(\d{2})(\d{2})(\d{4})/g);
      format = '$1/$2/$3'; // 27/02/2018
    } else if (type === 'addressNumber') {
      regex = new RegExp(/(\D)/g);
      format = ''; // 2111
    }

    formatted = value.replace(regex, format);
    return formatted;
  }

  lpad(n, width, z): string {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  getProductData() {
    this.catalogService.getProductForDisconnectedSale(this.productIdentifier).subscribe((res: any) => {
      this.productFamily = res.classification;
      this.productFamilyIdentifier = res.classificationIdentifier;
      this.productName = res.productName;
      this.valuePerMonth = res.installmentValue;
      this.totalValue = res.totalValue;
      this.productImg = res.productImg;
      this.installments = res.installment;
      this.productValue = res.productValue;
      this.productClassId = res.productClassId;
      this.discountedValue = res.discountedValue;
      this.disconnectedSaleService.setProductData(JSON.stringify(res));
      this.dtmService.productsLoaded([{
        identifier: this.productIdentifier,
        classificationName: this.productName,
        quantity: 1,
        totalValue: this.totalValue.replace(',','.'),
      },]);

      this.dtmService.pageLoaded(Dtm.CadastroDeslogado, true, getDtm(Dtm.CadastroDeslogado, this.productFamilyIdentifier));
      this.dtmService.sendPageLoadEvent();
    }
      , (error) => {

      }
    );
  }

}

